// extracted by mini-css-extract-plugin
module.exports = {"newsModal":"styles_newsModal__MTekr","contentContainer":"styles_contentContainer__3fqPv","image":"styles_image__KnfFV","codeContainer":"styles_codeContainer__3nlAL"};